<div class="logic-group root">
  @for (statementsList of filters()?.conditionalStatements; track $index) {
    @if ($index > 0) {
      <span
        class="logic-operator"
        [ngClass]="
          'logic-operator--' + filters()?.logicalOperator?.toLowerCase()
        "
      >
        {{ filters()?.logicalOperator?.toUpperCase() }}
      </span>
    }
    <div
      class="logic-group"
      [ngClass]="
        filters()?.conditionalStatements?.length === 1
          ? '!border-none'
          : getGroupClass(
              statementsList.logicalOperator,
              filters()?.logicalOperator
            )
      "
    >
      @for (condition of statementsList.conditions; track $index) {
        @if ($index > 0) {
          <span
            class="logic-operator"
            [ngClass]="
              'logic-operator--' + statementsList.logicalOperator?.toLowerCase()
            "
          >
            {{ statementsList?.logicalOperator?.toUpperCase() }}
          </span>
        }

        <div class="condition-pill">
          @if (isCategoryFilter(condition)) {
            <span
              class="clickable-item"
              (click)="categoryPopover.toggle($event)"
            >
              @if (condition.excludeProducts) {
                {{
                  'READABLE_FILTER_EXCLUDE_CATEGORIES'
                    | translate: {count: condition.categories.length}
                }}
              } @else {
                {{
                  'READABLE_FILTER_INCLUDE_CATEGORIES'
                    | translate: {count: condition.categories.length}
                }}
              }
            </span>
            <p-popover #categoryPopover>
              <ul
                class="max-h-[400px] max-w-[600px] overflow-auto list-disc list-outside pl-6"
              >
                @for (category of condition.categories; track category) {
                  <li>{{ category }}</li>
                }
              </ul>
            </p-popover>
          } @else if (isBestPriceFilter(condition)) {
            <span
              class="left-operand clickable-item"
              (click)="bestPricePopover.toggle($event)"
            >
              {{ getKeyDisplayName(condition.key) }}
            </span>
            <p-popover #bestPricePopover>
              <div class="flex items-center">
                @if (condition.toleranceEnabled) {
                  <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                } @else {
                  <ng-container
                    [ngTemplateOutlet]="disabledIcon"
                  ></ng-container>
                }
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_BEST_PRICE_TOLERANCE_1'
                    | translate
                }}
                @if (condition.toleranceEnabled) {
                  ( {{ condition.tolerancePercent / 100 | percent }})
                }
              </div>
              <div class="flex items-center">
                @if (condition.shippingCostsExcluded) {
                  <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                } @else {
                  <ng-container
                    [ngTemplateOutlet]="disabledIcon"
                  ></ng-container>
                }
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_BEST_PRICE_EXCLUDE_SHIPPING'
                    | translate
                }}
              </div>
              <div class="flex items-center">
                @if (condition.excludeProducts) {
                  <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                } @else {
                  <ng-container
                    [ngTemplateOutlet]="disabledIcon"
                  ></ng-container>
                }
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_EXCLUDE_PRODUCTS_LABEL'
                    | translate
                }}
              </div>
            </p-popover>
          } @else if (isMostUsedPriceFilter(condition)) {
            <span
              class="left-operand clickable-item"
              (click)="mostUsedPricePopover.toggle($event)"
            >
              {{ getKeyDisplayName(condition.key) }}
            </span>
            <p-popover #mostUsedPricePopover>
              <div class="popover-desc-text">
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_MODE_PRICE_V2_DESCRIPTION'
                    | translate
                }}
              </div>
              <div class="flex items-center">
                <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>

                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_' +
                    condition.rangeMode.toUpperCase() +
                    '_DROPDOWN_LABEL' | translate
                }}
              </div>
              <div class="flex items-center">
                @if (condition.shippingCostsExcluded) {
                  <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                } @else {
                  <ng-container
                    [ngTemplateOutlet]="disabledIcon"
                  ></ng-container>
                }
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_BEST_PRICE_EXCLUDE_SHIPPING'
                    | translate
                }}
              </div>
              <div class="flex items-center">
                @if (condition.excludeProducts) {
                  <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                } @else {
                  <ng-container
                    [ngTemplateOutlet]="disabledIcon"
                  ></ng-container>
                }
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_EXCLUDE_PRODUCTS_LABEL'
                    | translate
                }}
              </div>
            </p-popover>
          } @else if (isPriceChangesFilter(condition)) {
            <span
              class="left-operand clickable-item"
              (click)="mostUsedPricePopover.toggle($event)"
            >
              {{ getKeyDisplayName(condition.key) }}
            </span>
            <p-popover #mostUsedPricePopover>
              <div class="popover-desc-text">
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_PRICE_CHANGES_DESCRIPTION'
                    | translate
                }}
              </div>
              <div class="flex items-center">
                <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>

                {{
                  'G_FILTER_' + condition.column?.toUpperCase() + '_VALUE'
                    | translate
                }}
              </div>
              <div class="flex items-center">
                <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>

                {{ 'SHARED_LABEL_NUMBER_OF_CHANGES' | translate }}
                {{
                  'G_FILTER_' + condition.operator.toUpperCase() + '_VALUE'
                    | translate
                }}
                {{ condition.value }}
              </div>
              <div class="flex items-center">
                @if (condition.includeWithInsufficientData) {
                  <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                } @else {
                  <ng-container
                    [ngTemplateOutlet]="disabledIcon"
                  ></ng-container>
                }
                {{
                  'G_FILTER_PRICE_CHANGES_INCLUDE_WITH_INSUFFICIENT_DATA_INPUT_PLACEHOLDER'
                    | translate
                }}
              </div>
              <div class="flex items-center">
                @if (condition.source) {
                  <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                } @else {
                  <ng-container
                    [ngTemplateOutlet]="disabledIcon"
                  ></ng-container>
                }
                {{ 'SHARED_LABEL_SOURCE' | translate }}:
                {{ getSrouceName(condition.source) }}
              </div>
              <div class="flex items-center">
                @if (condition.toleranceEnabled) {
                  <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                } @else {
                  <ng-container
                    [ngTemplateOutlet]="disabledIcon"
                  ></ng-container>
                }
                {{
                  'G_FILTER_PRICE_CHANGES_TOLERANCE_ENABLED_INPUT_PLACEHOLDER'
                    | translate
                }}: {{ condition.tolerancePercent / 100 | percent }}
              </div>
            </p-popover>
          } @else if (isFetchStatusFilter(condition)) {
            <span class="left-operand">
              {{ getKeyDisplayName(condition.key) }}
            </span>
            <span class="arth-operator"
              >{{
                'OPERATOR_SYMBOL_' + condition.operator?.toUpperCase()
                  | translate
              }}
            </span>
            @if (condition.value) {
              {{
                'G_FILTER_' + condition.value.toUpperCase() + '_VALUE'
                  | translate
              }}
            }
          } @else if (isOutliersFilter(condition)) {
            <span
              class="left-operand clickable-item"
              (click)="bestPricePopover.toggle($event)"
            >
              {{ getKeyDisplayName(condition.key) }}
            </span>
            <p-popover #bestPricePopover>
              <div class="popover-desc-text">
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_OUTLIERS_DESCRIPTION' | translate
                }}
              </div>

              <div class="flex items-center">
                @if (condition.shippingCostsExcluded) {
                  <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                } @else {
                  <ng-container
                    [ngTemplateOutlet]="disabledIcon"
                  ></ng-container>
                }
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_BEST_PRICE_EXCLUDE_SHIPPING'
                    | translate
                }}
              </div>
              <div class="flex items-center">
                @if (condition.excludeProducts) {
                  <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                } @else {
                  <ng-container
                    [ngTemplateOutlet]="disabledIcon"
                  ></ng-container>
                }
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_EXCLUDE_PRODUCTS_LABEL'
                    | translate
                }}
              </div>
            </p-popover>
          } @else if (isDaysValueFilter(condition)) {
            <span class="left-operand">
              {{ getKeyDisplayName(condition.key) }}
            </span>
            <span class="arth-operator"
              >{{
                'OPERATOR_SYMBOL_' + condition.operator?.toUpperCase()
                  | translate
              }}
            </span>
            {{ condition?.days }}
            {{ 'G_FILTER_PRICE_CHANGES_DAYS_INPUT_PLACEHOLDER' | translate }}
          } @else if (isWithCompetitorsFilter(condition)) {
            <span class="left-operand">
              {{ getKeyDisplayName(condition.key) }}
            </span>
            @if (condition.operator) {
              <span class="arth-operator"
                >{{
                  'OPERATOR_SYMBOL_' + condition.operator?.toUpperCase()
                    | translate
                }}
              </span>
              {{ condition?.value }}
            }

            @if (condition.source) {
              ({{ getSrouceName(condition.source) }})
            }
          } @else if (isProductPerformanceFilter(condition)) {
            <span
              class="left-operand clickable-item"
              (click)="performancePopover.toggle($event)"
            >
              {{ getKeyDisplayName(condition.key) }}
            </span>
            <p-popover #performancePopover>
              <div class="popover-desc-text">
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_PRODUCT_PERFORMANCE_DESCRIPTION'
                    | translate
                }}
              </div>
              <div class="flex items-center">
                <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                {{ 'CAMPAIGN_PERFORMANCE_FILTER_ROAS' | translate }}
                <span class="mx-2">&lt;</span>
                <strong>{{ condition.roas }}</strong>
              </div>
              <div class="flex items-center">
                <ng-container [ngTemplateOutlet]="enabledIcon"></ng-container>
                {{
                  'CAMPAIGN_PERFORMANCE_FILTER_PRODUCT_PERFORMANCE_COSTS_PLACEHOLDER'
                    | translate
                }}
                <span class="mx-2">=</span>
                <strong>{{ condition.costs }}</strong>
              </div>
            </p-popover>
          } @else if (isLogicalConditionFilter(condition)) {
            <span class="left-operand">
              {{ getKeyDisplayName(condition.key) }}
            </span>
            <span class="arth-operator"
              >{{
                'OPERATOR_SYMBOL_' + condition.operator?.toUpperCase()
                  | translate
              }}
            </span>
            {{ condition.rightOperand?.value }}
          } @else {
            <span class="right-operand">
              {{ 'COLUMN_' + condition.key.toUpperCase() | translate }}
            </span>
          }
        </div>
      }
    </div>
  }
</div>

<ng-template #enabledIcon>
  <mat-icon class="text-success-400 mr-2">check</mat-icon>
</ng-template>

<ng-template #disabledIcon>
  <mat-icon class="text-danger-400 mr-2">close</mat-icon>
</ng-template>
